// extracted by mini-css-extract-plugin
module.exports = {"cover-image":"magazine-cover-image-m__cover-image__3WKPC","image":"magazine-cover-image-m__image__1IJWf"};